import AtAGlance from "@/components/sections/products/shared/at-a-glance";

const ROWS = [
  { label: "Starting price", value: "Self-serve plans start at $50 for 25 GB ($2/GB)" },
  { label: "Network", value: "4G/5G mobile IPs" },
  { label: "Targeting", value: "Country, city, ASN/ISP" },
  { label: "Sessions", value: "Rotating or sticky, up to 3 days" },
  { label: "Protocols", value: "HTTP, HTTPS, SOCKS5" },
  { label: "Authentication", value: "Username/password or IP whitelist" },
  { label: "Access points", value: "No cap" },
  { label: "KYC", value: "Required" },
];

export default function MobileAtAGlance() {
  return (
    <AtAGlance
      headingId="mobile-at-a-glance-heading"
      heading="Proxidize Mobile Proxies at a Glance"
      intro="Proxidize provides managed 4G/5G mobile proxies with premium pooled mobile IPs, rotating and sticky sessions, city- and ASN/ISP-level targeting, and HTTP(S)/SOCKS5 support. Self-serve plans are monthly bandwidth packages starting at $50 for 25 GB ($2/GB), with no cap on access points and full API access. KYC is required."
      rows={ROWS}
    />
  );
}
